<div [id]="chartContainerId" [style.height.px]="companyId === 4 ? 200 : (companyId === 20 ? 600 : 400)" style="width: 100%;"></div>

<!-- Store legend below the chart -->
<!-- <div class="store-legend" *ngIf="storeData.length > 0 &&  companyId !== 20">
  <div class="legend-item" *ngFor="let store of storeData">
    <span class="legend-color" [style.background-color]="store.color"></span>
    <span class="legend-name">{{ store.name }}</span>
    <span class="legend-value">{{ store.value }}</span>
  </div> -->
